import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Check from '@serko/zui-icons/es/CheckIcon';
import React, { Dispatch, PureComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action } from 'redux';
import { createSelector } from 'reselect';
import messages from '../intl/messages';
import { ItineraryStatus } from '../models/itinerary';
import { AppState } from '../store/model';
import { toggleConfirmDialog } from '../store/reducers/confirm-dialog/actions';
import {
  hasSegments,
  isLoading,
  isNew,
} from '../store/reducers/itinerary/selectors';
import { hasChosenAlternatives } from '../store/reducers/selected-options/selectors';
import { Footer as FooterLab } from './lab/Footer';
import { FooterButton } from './lab/FooterButton';

interface OwnProps {}

interface StateProps {
  disabled: boolean;
  show: boolean;
  anyAlternatesChosen: boolean;
}

interface DispatchProps {
  openDialog(itineraryStatus: ItineraryStatus): void;
}

interface FooterProps
  extends OwnProps,
    StateProps,
    DispatchProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

class FooterBase extends PureComponent<FooterProps> {
  public render() {
    const {
      show,
      disabled,
      classes,
      anyAlternatesChosen,
      intl: { formatMessage },
    } = this.props;

    if (!show) return null;

    return (
      <FooterLab>
        <FooterButton
          secondary
          disabled={disabled}
          onClick={this.openDialogReject}
        >
          {formatMessage(messages.common.requestChanges)}
        </FooterButton>
        <FooterButton
          disabled={disabled}
          onClick={this.openDialog(
            anyAlternatesChosen ? 'AcceptedWithChanges' : 'Accepted',
          )}
        >
          <Check className={classes.buttonIcon} />
          {formatMessage(messages.common.next)}
        </FooterButton>
      </FooterLab>
    );
  }
  private openDialogReject = () => {
    this.props.openDialog('Rejected');
  };

  private openDialog = (status: ItineraryStatus) => () =>
    this.props.openDialog(status);
}

const shouldDisableButtons = createSelector(
  isLoading,
  hasSegments,
  isNew,
  (loading, hasItinerary, newItinerary) => {
    return loading || !hasItinerary || !newItinerary;
  },
);

const mapStateToProps = (state: AppState): StateProps => ({
  disabled: shouldDisableButtons(state),
  show: isNew(state),
  anyAlternatesChosen: hasChosenAlternatives(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  openDialog(itineraryStatus: ItineraryStatus) {
    dispatch(toggleConfirmDialog(true, itineraryStatus));
  },
});

// styled
const styles = (theme: Theme) =>
  createStyles({
    buttonIcon: {
      marginRight: theme.spacing.unit,
    },
  });

/**
 * Footer component with action buttons (e.g. "Request changes" & "Next")
 */
export const Footer = compose<FooterProps, OwnProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  injectIntl,
)(FooterBase);

Footer.displayName = 'Footer';
